import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { event, getCampaignParams } from '@minerva-analytics/pantheon';
import { connect } from 'react-redux';

import pendingActions from 'store/pending/actions';
import subscriberActions from 'store/subscriber/actions';

import { SIGN_MAPPING } from 'utils/signs';
import { trackFacebookConversion, trackGoogleConversion, trackTaboolaConversion } from 'utils';
import { StyledButton } from '../../styled_constants';
import capitalize from '../../oldpantheon/utils/capitalize';
import PendingForm from '../../oldpantheon/components/PendingForm';

import {
  SignSelect,
  EmailInput,
  LegalText,
  HelpBlock,
  SignUpButtonWrapper,
} from './SignUpForm.styles';

const PENDING_KEY = `signup`;

export class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationState: true,
      message: ``,
    };
  }

  setValidation = (validationState, message) =>
    this.setState({ validationState, message });

  postEmail = async (data) => {
    const { createSubscriber, referralId } = this.props;
    const { email, sign } = data;

    if (!email) {
      this.setValidation(false, `Please enter your email`);
      return;
    }
    if (!sign) {
      this.setValidation(false, `Please select a sign`);
      return;
    }

    const piwikParams = getCampaignParams();

    const postData = {
      email: email.trim(),
      metafield: {
        sign,
      },
      domain: `starguide`,
      ...piwikParams,
      ...{ ref: referralId },
    };

    try {
      const subscriber = await createSubscriber(postData);
      const timeBetween = (new Date(subscriber.updated_ts) - new Date(subscriber.created_ts));
      const secondsBetween = timeBetween / 1000;
      if (secondsBetween > 1) {
        this.setValidation(true, `You have successfully updated your sign. Thank you!`);
        event([`user-update`, sign, subscriber.id]);
      } else {
        this.setValidation(true, `Thanks for signing up! Please check your email for a Starguide message to confirm your subscription. Don’t forget to check your spam folder - just in case!`);
        event([`user-create`, sign, subscriber.id]);
        trackFacebookConversion(`CompleteRegistration`, `{'content_name': 'email-subscription'}`);
        trackGoogleConversion();
        trackTaboolaConversion(`CompleteRegistration`);
      }
    } catch (err) {
      const errorMessage = err.message ? err.message : `We encountered an error. Please check that you have chosen a sign and a valid email.`;
      event([`user-failure`, errorMessage]);
      this.setValidation(
        false,
        errorMessage,
      );
    }
  }

  handleSignChange = (e) => {
    this.props.updatePendingData({
      id: PENDING_KEY,
      changes: { sign: e.target.value },
    });
  }


  render() {
    const { ...rest } = this.props;
    const { sign } = this.props;
    const { validationState } = this.state;
    const selectItems = Object.keys(SIGN_MAPPING).map((s) => ({
      label: capitalize(s),
      value: s,
    }));
    // Add the first option to select a sign
    selectItems.unshift({ label: `Choose a sign`, value: `` });
    return (
      <React.Fragment>
        <PendingForm id={ PENDING_KEY } onSubmit={ this.postEmail } {...rest}>
          <EmailInput
            pendingKey={ PENDING_KEY }
            valueKey="email"
            placeholder="Your email"
            type="email"
            validationState={ validationState }
            stacked={this.props.stacked}
          />
          <SignSelect
            items={ selectItems }
            onChange={ this.handleSignChange }
            value={ sign }
            stacked={this.props.stacked}
          />
          <HelpBlock validationState={ validationState }>
            { this.state.message }
          </HelpBlock>
          <SignUpButtonWrapper>
            <StyledButton
              type="submit"
              onClick={() => event([`click`, `subscribe-btn`, `${this.props.formPlacement}`])}
            >
              Sign up for daily horoscopes
            </StyledButton>
          </SignUpButtonWrapper>
          <LegalText>
            By signing up for Starguide Daily Horoscopes, you are agreeing to the
            <Link to={ `/privacy` } onClick={this.props.closeModal}> privacy policy</Link> and
            <Link to={ `/terms` } onClick={this.props.closeModal}> terms of service</Link>.
          </LegalText>
        </PendingForm>
      </React.Fragment>
    );
  }
}

SignUpForm.propTypes = {
  updatePendingData: PropTypes.func.isRequired,
  sign: PropTypes.string,
  closeModal: PropTypes.func,
  stacked: PropTypes.bool,
  formPlacement: PropTypes.string,
};

export default connect((state) => ({
  sign: state.pending.data[PENDING_KEY]
    ? state.pending.data[PENDING_KEY].sign
    : ``,
  referralId: state.referral,
}), {
  updatePendingData: pendingActions.updatePendingData,
  createSubscriber: subscriberActions.createSubscriber,

})(withRouter(SignUpForm));
